import { GenericProvider, Provider } from "@/services/data/generic-provider";
import { baseAPIUrl } from "@/services/utils/utils";
import { IEmailConfirmationResponse } from "./email-confirmation-types";

@Provider(`${baseAPIUrl}/user/email/confirm`)
class EmailConfirmProvider extends GenericProvider<IEmailConfirmationResponse> {}

export const emailConfirmProvider = new EmailConfirmProvider();
